import posthog from 'posthog-js';

const isProd = import.meta.env.VITE_ENV === 'production';
export const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
export const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

// Helper to check if PostHog is properly configured
export const isPostHogEnabled = (): boolean => {
  return isProd && !!posthogKey && !!posthogHost;
};
export const isFeatureEnabled = (flagKey: string): boolean => {
  if (!isProd) {
    return true;
  }
  if (!isPostHogEnabled()) {
    return false;
  }
  try {
    return posthog.isFeatureEnabled(flagKey) ?? false;
  } catch (error) {
    console.error('Error checking feature flag:', error);
    return false;
  }
};

export const identifyUser = (
  user_id: string,
  email: string,
  org_id: string,
  name: string
) => {
  if (!isPostHogEnabled()) {
    return;
  }
  posthog.identify(user_id, { email, org_id, name });
};

export const resetUser = () => {
  if (!isPostHogEnabled()) {
    return;
  }
  posthog.reset();
};
